export default "__VITE_ASSET__eRFfVZ13__"